(function($){

    var fadeAnimating       = false,
        slideInAnimating    = false,
        dropInAnimating     = false;

    var methods = {
        fade:       function(speed){
            if(!fadeAnimating){
                this.hide();
                fadeIn(0, this, speed);
            }
        },
        
        dropIn:     function(speed){
            if(!dropInAnimating){
                $.each(this, function(i,el){
                    var $el         = $(el),
                        defaultTop  = ($el.css('top') == 'auto') ? '0px' : $el.css('top');

                    $el.attr('jqao-top', defaultTop).css('top', '-1500px');
                });

                dropIn(0,this,speed);
            }
        },
    };

    $.fn.animateOrder = function(methodOrOptions){
        if(methods[methodOrOptions]){
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if(typeof methodOrOptions === 'object' || !methodOrOptions){
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' +  methodOrOptions + ' does not exist on jQuery.animate.order');
        }
    };

    function fadeIn(i,elements,speed,callback)
    {
        if(i >= elements.length){
            fadeAnimating = false;
            typeof callback == 'function' && callback();
        } else {
            fadeAnimating = true;
            elements.eq(i).fadeIn(speed, function(){
                fadeIn(i+1, elements, speed, callback);
            });
        }
    }

    function dropIn(i,elements,speed,callback){
        if(i >= elements.length){
            dropInAnimating = false;
            typeof callback == 'function' && callback();
        } else {
            dropInAnimating = true;
            var topPos = elements.eq(i).attr('jqao-top');

            elements.eq(i).stop(true,true).animate({
                top: topPos
            }, speed, function(){
               dropIn(i+1, elements, speed, callback);
            });
        }
    }

})(jQuery);